import React from "react";

function Footer() {
  return (
    <footer className="footer footer-center p-4 bg-slate-900 text-white relative">
      <aside>
        <p>Copyright © 2023 - Coded by Concrete Code</p>
      </aside>
    </footer>
  );
}

export default Footer;
